<template>
  <div
    style="
      width: 6000px;
      background-color: #f5f8fa;
      display: flex;
      justify-content: center;
    "
  >
    <div
      v-if="bademon"
      style="
        position: fixed;
        top: 0;
        z-index: 999;
        height: 100vh;
        width: 100vw;
        background-color: rgba(204, 204, 204, 0.7);
      "
    ></div>
    <div
      v-if="bademon"
      style="
        width: 346px;
        height: 320px;
        background-color: #fff;
        position: fixed;
        top: 30%;
        z-index: 1000;

        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        border-radius: 10px;

        /* padding: 38px;
        box-sizing: border-box; */
      "
    >
      <i
        class="el-icon-close"
        style="position: absolute; top: 10px; right: 10px"
        @click="unInquiry()"
      ></i>
      <div
        style="font-size: 20px; color: rgba(51, 51, 51, 1); font-weight: 500"
      >
        免费定制专属网校
      </div>
      <el-select
        v-model="value"
        placeholder="请选择您所在的行业"
        style="height: 40px; width: 270px; margin: 24px 0 16px 0"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-input
        v-model="input"
        placeholder="请输入您的联系方式"
        style="height: 40px; width: 270px"
      ></el-input>
      <div
        style="
          height: 40px;
          width: 270px;
          font-size: 14px;
          color: #0274f7;
          margin: 10px 0 20px 0;
        "
      >
        提交即可获取30天免费试用
      </div>
      <el-button
        @click="submitPhone"
        type="primary"
        style="
          height: 40px;
          width: 270px;
          background-color: #0274f7;
          color: #fff;
        "
        >提交</el-button
      >
    </div>
    <div style="height: 850px; width: 1440px; background-color: #f5f8fa">
      <div class="title">
        <span>特色功能</span>
      </div>
      <div class="label">
        <div
          class="content"
          :class="classIndex == 1 ? 'active' : ''"
          @click="handleSwitch(1)"
        >
          <img
            style="width: 40px; height: 40px"
            :src="
              classIndex == 1
                ? require('../assets/official/after1.png')
                : require('../assets/official/before1.png')
            "
            alt=""
          />
          用户触达
        </div>
        <div
          class="content"
          :class="classIndex == 2 ? 'active' : ''"
          @click="handleSwitch(2)"
        >
          <img
            style="width: 40px; height: 40px"
            :src="
              classIndex == 2
                ? require('../assets/official/after2.png')
                : require('../assets/official/before2.png')
            "
            alt=""
          />
          用户标签
        </div>
        <div
          class="content"
          :class="classIndex == 3 ? 'active' : ''"
          @click="handleSwitch(3)"
        >
          <img
            style="width: 40px; height: 40px"
            :src="
              classIndex == 3
                ? require('../assets/official/after3.png')
                : require('../assets/official/before3.png')
            "
            alt=""
          />
          数据运营
        </div>
        <div
          class="content"
          :class="classIndex == 4 ? 'active' : ''"
          @click="handleSwitch(4)"
        >
          <img
            style="width: 40px; height: 40px"
            :src="
              classIndex == 4
                ? require('../assets/official/after4.png')
                : require('../assets/official/before4.png')
            "
            alt=""
          />
          品牌化
        </div>
        <div
          class="content"
          :class="classIndex == 5 ? 'active' : ''"
          @click="handleSwitch(5)"
        >
          <img
            style="width: 40px; height: 40px"
            :src="
              classIndex == 5
                ? require('../assets/official/after5.png')
                : require('../assets/official/before5.png')
            "
            alt=""
          />
          AI员工
        </div>
      </div>
      <div class="img-text">
        <div style="height: 485px; width: 1200px; overflow: hidden">
          <div
            v-if="classIndex == 1"
            style="
              height: 485px;
              width: 1200px;
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <div class="left">
              <div style="font-size: 24px; color: #0d1b27; margin-top: 64px">
                精准连接，触达无限可能
              </div>
              <div
                style="width: 25px; border: 1px solid #333; margin-top: 12px"
              ></div>
              <div
                style="
                  width: 360px;
                  border-top: 1px solid rgba(51, 51, 51, 0.06);
                "
              ></div>
              <div class="yes-text" style="margin-top: 25px">
                <img
                  style="width: 15px; height: 16px; margin-right: 4px"
                  src="../assets/official/yes.png"
                  alt=""
                />
                多渠道触达，包括IM、语音短信等，全方位覆盖用户。
              </div>
              <div class="yes-text">
                <img
                  style="width: 15px; height: 16px; margin-right: 4px"
                  src="../assets/official/yes.png"
                  alt=""
                />个性化触达内容，以用户行为和偏好定制消息。
              </div>
              <div class="yes-text">
                <img
                  style="width: 15px; height: 16px; margin-right: 4px"
                  src="../assets/official/yes.png"
                  alt=""
                />实时触达，确保沟通及时和有效。
              </div>
              <div
                @click="inquiry()"
                style="
                  width: 140px;
                  height: 44px;
                  color: #fff;
                  background-color: #0274f7;
                  border-radius: 2px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  font-size: 18px;
                  margin-top: 60px;
                "
              >
                立即咨询
              </div>
            </div>
            <div class="right">
              <img
                class="right"
                src="../assets/official/Group 48001@2x.png"
                alt=""
              />
            </div>
          </div>
          <div
            v-if="classIndex == 2"
            style="
              height: 434px;
              width: 1200px;
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <div class="left">
              <div style="font-size: 24px; color: #0d1b27; margin-top: 64px">
                精准画像，洞察用户需求
              </div>
              <div
                style="width: 25px; border: 1px solid #333; margin-top: 12px"
              ></div>
              <div
                style="
                  width: 360px;
                  border-top: 1px solid rgba(51, 51, 51, 0.06);
                "
              ></div>
              <div class="yes-text" style="margin-top: 25px">
                <img
                  style="width: 15px; height: 16px; margin-right: 4px"
                  src="../assets/official/yes.png"
                  alt=""
                />
                多维度标签管理，全面描绘用户特征。
              </div>
              <div class="yes-text">
                <img
                  style="width: 15px; height: 16px; margin-right: 4px"
                  src="../assets/official/yes.png"
                  alt=""
                />动态更新标签，实时反映用户变化。
              </div>
              <div class="yes-text">
                <img
                  style="width: 15px; height: 16px; margin-right: 4px"
                  src="../assets/official/yes.png"
                  alt=""
                />精准化的标签营销，提升服务效果。
              </div>
              <div
                @click="inquiry()"
                style="
                  width: 140px;
                  height: 44px;
                  color: #fff;
                  background-color: #0274f7;
                  border-radius: 2px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  font-size: 18px;
                  margin-top: 60px;
                "
              >
                立即咨询
              </div>
            </div>
            <div class="right">
              <img
                class="right"
                src="../assets/official/Group 48010@2x.png"
                alt=""
              />
            </div>
          </div>
          <div
            v-if="classIndex == 3"
            style="
              height: 434px;
              width: 1200px;
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <div class="left">
              <div style="font-size: 24px; color: #0d1b27; margin-top: 64px">
                数据驱动，智慧运营
              </div>
              <div
                style="width: 25px; border: 1px solid #333; margin-top: 12px"
              ></div>
              <div
                style="
                  width: 360px;
                  border-top: 1px solid rgba(51, 51, 51, 0.06);
                "
              ></div>
              <div class="yes-text" style="margin-top: 25px">
                <img
                  style="width: 15px; height: 16px; margin-right: 4px"
                  src="../assets/official/yes.png"
                  alt=""
                />
                全面数据采集，洞察链路全景。
              </div>
              <div class="yes-text">
                <img
                  style="width: 15px; height: 16px; margin-right: 4px"
                  src="../assets/official/yes.png"
                  alt=""
                />深度数据分析，挖掘潜在价值。
              </div>
              <div class="yes-text">
                <img
                  style="width: 15px; height: 16px; margin-right: 4px"
                  src="../assets/official/yes.png"
                  alt=""
                />决策数据支持，优化运营策略。
              </div>
              <div
                @click="inquiry()"
                style="
                  width: 140px;
                  height: 44px;
                  color: #fff;
                  background-color: #0274f7;
                  border-radius: 2px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  font-size: 18px;
                  margin-top: 60px;
                "
              >
                立即咨询
              </div>
            </div>
            <div class="right">
              <img
                class="right"
                src="../assets/official/Group 48002@2x.png"
                alt=""
              />
            </div>
          </div>
          <div
            v-if="classIndex == 4"
            style="
              height: 434px;
              width: 1200px;
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <div class="left">
              <div style="font-size: 24px; color: #0d1b27; margin-top: 64px">
                塑造品牌，提升价值
              </div>
              <div
                style="width: 25px; border: 1px solid #333; margin-top: 12px"
              ></div>
              <div
                style="
                  width: 360px;
                  border-top: 1px solid rgba(51, 51, 51, 0.06);
                "
              ></div>
              <div class="yes-text" style="margin-top: 25px">
                <img
                  style="width: 15px; height: 16px; margin-right: 4px"
                  src="../assets/official/yes.png"
                  alt=""
                />
                定制化品牌形象，展现个性风采。
              </div>
              <div class="yes-text">
                <img
                  style="width: 15px; height: 16px; margin-right: 4px"
                  src="../assets/official/yes.png"
                  alt=""
                />品牌化传播，提升知名度。
              </div>
              <div class="yes-text">
                <img
                  style="width: 15px; height: 16px; margin-right: 4px"
                  src="../assets/official/yes.png"
                  alt=""
                />品牌忠诚度培养，增强用户粘性。
              </div>
              <div
                @click="inquiry()"
                style="
                  width: 140px;
                  height: 44px;
                  color: #fff;
                  background-color: #0274f7;
                  border-radius: 2px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  font-size: 18px;
                  margin-top: 60px;
                "
              >
                立即咨询
              </div>
            </div>
            <div class="right">
              <img
                class="right"
                src="../assets/official/Group 48036.png"
                alt=""
              />
            </div>
          </div>
          <div
            v-if="classIndex == 5"
            style="
              height: 434px;
              width: 1200px;
              display: flex;
              align-items: center;
              justify-content: space-between;
            "
          >
            <div class="left">
              <div style="font-size: 24px; color: #0d1b27; margin-top: 64px">
                智能助手，高效服务
              </div>
              <div
                style="width: 25px; border: 1px solid #333; margin-top: 12px"
              ></div>
              <div
                style="
                  width: 360px;
                  border-top: 1px solid rgba(51, 51, 51, 0.06);
                "
              ></div>
              <div class="yes-text" style="margin-top: 25px">
                <img
                  style="width: 15px; height: 16px; margin-right: 4px"
                  src="../assets/official/yes.png"
                  alt=""
                />
                24 h在线，随时响应需求。
              </div>
              <div class="yes-text">
                <img
                  style="width: 15px; height: 16px; margin-right: 4px"
                  src="../assets/official/yes.png"
                  alt=""
                />智能答疑，准确问题解决。
              </div>
              <div class="yes-text">
                <img
                  style="width: 15px; height: 16px; margin-right: 4px"
                  src="../assets/official/yes.png"
                  alt=""
                />辅助学习，提供个性化陪练。
              </div>
              <div
                @click="inquiry()"
                style="
                  width: 140px;
                  height: 44px;
                  color: #fff;
                  background-color: #0274f7;
                  border-radius: 2px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  font-size: 18px;
                  margin-top: 60px;
                "
              >
                立即咨询
              </div>
            </div>
            <div class="right">
              <img
                class="right"
                src="../assets/official/Group 48034.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import Cookies from 'js-cookie'
export default {
  name: 'HelloWorld',
  data() {
    return {
      bademon: false,
      options: [
        {
          value: '知识付费',
          label: '知识付费',
        },
        {
          value: '兴趣培训',
          label: '兴趣培训',
        },
        {
          value: '大健康',
          label: '大健康',
        },
        {
          value: 'K12教育',
          label: 'K12教育',
        },
        {
          value: '企业培训',
          label: '企业培训',
        },
        {
          value: '医疗美容',
          label: '医疗美容',
        },
      ],
      value: '',
      input: '',
      classIndex: 1,
      newsList: [],
    }
  },

  created() {},
  destroyed() {},
  mounted() {},
  methods: {
    //提交留资信息
    submitPhone() {
      const ccc =
        /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/
      if (this.input && this.value && ccc.test(this.input)) {
        axios
          .get(
            'https://manager-api.mischool.com.cn' +
              '/official/mail?' +
              'mobile=' +
              this.input +
              '&industry=' +
              this.value
          )
          .then((res) => {
            if (res.data.code === 200) {
              console.log('发送成功')
              this.bademon = false
              this.$message.success('提交成功')
              this.input = ''
              this.value = ''
            }
          })
      } else {
        this.$message.error('请选择行业或输入手机号')
      }
    },
    // 打开留资弹窗
    inquiry() {
      this.bademon = true
    },
    // 关闭留资弹窗
    unInquiry() {
      this.bademon = false
    },
    handleSwitch(index) {
      this.classIndex = index
    },
  },
  beforeDestroy() {},
}
</script>
<style scoped lang="scss">
.title {
  padding-top: 50px;
  width: 100%;
  height: 136px;
  // background-color: #666;
  font-size: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.label {
  display: flex;
  justify-content: center;
  align-items: center;

  .content {
    cursor: pointer;
    margin: 0 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 76px;
    width: 222px;
    background-color: #fff;
    border-radius: 4px;
    font-size: 18px;
  }
  .active {
    background-image: linear-gradient(to right, #03a0fc, #0274f7);
    color: #fff;
  }
}
.img-text {
  display: flex;
  align-items: center;
  margin-top: 60px;
  height: 485px;
  width: 100%;
  padding: 0 118px;
  .left {
    height: 100%;
    width: 38%;
    // background-color: #ccc;
    .yes-text {
      display: flex;
      align-items: center;
      margin: 38px 0;
      font-size: 16px;
      color: #909399;
    }
  }
  .right {
    height: 485px;
    width: 654px;
  }
}
</style>
